import React from "react";
import Navbar from "./Component/Navbar";
import Routes from "./routes";
import './App.css';
import Footer from "./Component/Footer";

const App = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Routes />
      <Footer />
    </React.Fragment>
  );
};

export default App;
